import {
  blacklistedPages,
  EVENT_MODAL_CLOSED,
  EVENT_MODAL_INPUT_CLICKED,
  EVENT_MODAL_SUBMIT_MAN,
  EVENT_MODAL_SUBMIT_WOMAN,
  NEWSLETTER_MODAL_ID,
} from 'shared/experiments/browser/newsletterModalFR/consts'
import mountNewsletterModalContainer from 'shared/experiments/components/NewsletterModal/mountNewsletterModalFormContainer'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'

export const triggerNewsletterModal = () => {
  setTimeout(async function () {
    window.location.hash = NEWSLETTER_MODAL_ID
    window.sessionStorage.setItem(NEWSLETTER_MODAL_ID, 'true')
    await mountNewsletterModalContainer()
    window._uxa = window._uxa || []
    window._uxa.push([
      'trackPageview',
      `${window.location.pathname}${window.location.hash.replace('#', '/__')}`,
    ])

    document
      .getElementById(NEWSLETTER_MODAL_ID)
      ?.addEventListener('click', (event: Event) => {
        const target = <HTMLElement>event.target
        if (target?.closest('#subscribe-for-woman')) {
          trackEvent(EVENT_MODAL_SUBMIT_WOMAN)
        }

        if (target.closest('#subscribe-for-man')) {
          trackEvent(EVENT_MODAL_SUBMIT_MAN)
        }

        if (target.closest('#newsletterEmail')) {
          trackEvent(EVENT_MODAL_INPUT_CLICKED)
        }

        if (
          target.closest('[data-clientside-hook~="NewsletterModalCloser"]') ||
          target.closest('.m-Modal__backdrop')
        ) {
          trackEvent(EVENT_MODAL_CLOSED)
        }
      })
  }, 3000)
}

export const isPageBlacklisted = (page: string) =>
  blacklistedPages.includes(page)
